var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPage = function SvgPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D5D8E0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.555 18.691h17.112v-2.79H5.555v2.79Zm0 5.58h17.112v-2.79H5.555v2.79Zm0 5.58h17.112v-2.79H5.555v2.79Zm16.951-17.11V4.185A4.185 4.185 0 0 0 18.321 0H0v41.616h36.642v-24.69a4.185 4.185 0 0 0-4.185-4.185h-9.951Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.296 4.848V9.95h5.662z"
  }))));
};
export default SvgPage;